/**
 * Created by DejanK on 12/19/2016.
 */
import './pricing.scss'
import { noop } from 'lodash'
import HTML from './pricing.html'

export { noop as Controller, HTML }
